module.exports = __webpack_public_path__ + "img/pin.e3d35e8d.svg";